import { handleRoutes, routeTo, __resetRouteHandler } from './routeHandler';

export { handleRoutes, routeTo, __resetRouteHandler };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-util-route-handler/es/index.js
// module id = 618
// module chunks = 0